import {useAppSelector} from '@/hooks';
import {useGetNumberOfPages} from '@Hooks/poster-editor/useGetNumberOfPages';

export const useIsVideoOrHasMultiPages = (): boolean => {
  const isPosterVideo =
    useAppSelector((state) => {
      return state.posterEditor.isPosterVideo;
    }) ?? false;
  const numPages = useGetNumberOfPages();

  return numPages > 1 || isPosterVideo;
};
